<template>
  <section class="main-title-container">
    <h1>{{ title }}</h1>
    <p class="subtitle" v-html="subTitle"></p>
    <slot></slot>
  </section>
</template>
<script>
export default {
  props: ['title', 'subTitle'],
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.mobile {
  .main-title-container {
    margin-right: auto;
  }
}
.main-title-container {
  //text-align: center;
  padding-left: 12px;
  margin-top: 20px;
  margin-right: 158px;

  h1 {
    font-size: 19px;
    font-weight: 500;
    color: var(--main-color);
    margin-bottom: 10px;
  }

  p {
    font-size: 13px;
    color: var(--sub-color);
    line-height: 18px;
  }

  .subtitle {
    margin-bottom: 25px;
  }

  .buttons {
    button {
      margin: 0 10px;
    }
  }
}
</style>
